import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[customForm]'
})
export class CustomFormDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
